module.exports = __webpack_public_path__ + "c23630e2ea1475143e9cd57f1b4c56a6.png";